import TransferProductSnListDialog from "./transferProductSnListDialog.container";

export default TransferProductSnListDialog;
